/* eslint-disable max-len */
import {
    useEffect,
    useState, useMemo,
} from 'react'
import isEqual from 'lodash/isEqual'
import isFunction from 'lodash/isFunction'
import isNil from 'lodash/isNil'
import {
    Validate,
} from 'app/types/form.types'

export default function useValidateItem({
    validate,
    value,
    setFormError,
    key,
    returnOnFirstError = true,
}: {
    validate: Validate | Validate[],
    value: any,
    setFormError?: (e:[string, any[]]) => void,
    key?: string,
    returnOnFirstError?: boolean,
}) {
    const [
        errors,
        setErrors,
    ] = useState<string[]>()
    const [
        validated,
        setValidated,
    ] = useState<boolean>(false)

    useEffect(() => {
        let next
        let isValidated: boolean = false // define if we need validation (validate return not undefined at least once)
        let isValid: boolean = true // define success of validation

        if (!validate) return
        const v = (isFunction(validate) ? [validate] : validate) as Validate[]

        for (let i = 0; i < v.length; i++) {
            const result = v[i](value)

            if (!isNil(result)) {
                isValidated = true
                isValid = isValid && Boolean(result)
            }

            if (result && Array.isArray(result)) {
                next = next?.length ? [
                    ...next,
                    ...result,
                ] : result
                if (returnOnFirstError) break
            }
        }

        const calculatedValidated = isValidated ? isValid : false

        if (validated !== calculatedValidated) {
            setValidated(calculatedValidated)
        }

        if (!isEqual(next, errors)) {
            if (setFormError) {
                setFormError([
                    key,
                    next,
                ])

                setErrors(next)
            }
        }
    }, [
        value,
        errors,
        setFormError,
        key,
        returnOnFirstError,
        validate,
        validated,
    ])

    return useMemo(() => {
        return {
            errors, validated,
        }
    }, [
        errors,
        validated,
    ])
}
